const SentrySymbol = Symbol();
const SENTRY_DSN =
  'https://520518d9a12f22686e03c494811f4081@sentry.farabixo.com/4';

export { SENTRY_DSN, SentrySymbol };
